import { createRoute, redirect } from '@tanstack/react-router';
import { rutaInicialDe } from '../nucleo/autorizacion/sesion.js';
import { rutaRaiz } from './raiz.js';

/**
 * EL DOMINIO PELADO. Sin esta ruta, quien escribe la dirección de la aplicación sin nada
 * más aterriza en el `notFound` del router: la pantalla dice «Not Found» sobre el fondo de
 * la marca y no hay un solo error en consola que lo explique.
 *
 * Es el defecto espejo del que motivó `arbol.test.ts`. Aquella prueba comprueba que todo
 * destino del guardián exista y que toda ruta declarada esté colgada, y las dos preguntas
 * pasaban en verde: `/` no es destino de nadie y ningún archivo la declaraba. **Las cuatro
 * pruebas de extremo a extremo tampoco la tocan**, porque cada una entra por su dirección
 * concreta. Así que la única dirección que todo usuario va a escribir era la única que
 * nadie había abierto, y se descubrió desplegando, el 2026-09-28.
 *
 * NO DECIDE NADA POR SU CUENTA: reenvía a `rutaInicialDe`, que es la misma función con la
 * que la pantalla de ingreso reparte a cada rol. Duplicar ese `switch` acá sería tener dos
 * respuestas para «a dónde va un contador», y la que se equivocaría es la copia.
 *
 * Y no lleva guardián a propósito. Sin sesión, `rutaInicialDe` ya devuelve `/ingresar`,
 * que es lo mismo que haría el guardián pero sin el `motivo` de error en la URL: quien
 * entra por la puerta principal no llegó rebotado de ninguna parte, y no tiene por qué
 * leer «E_NO_AUTENTICADO» como bienvenida.
 */
export const rutaIndice = createRoute({
  getParentRoute: () => rutaRaiz,
  path: '/',
  beforeLoad: ({ context }) => {
    throw redirect({ to: rutaInicialDe(context.sesion?.rol), replace: true });
  },
});
